module.exports = __webpack_public_path__ + "media/images/area/feature/chugoku/hero-ec2e79c861549c5fe42e65675ed00c14.jpg";